export const waterLocateRequiredCities = [
  "allen",
  "plano",
  "frisco",
  "dallas",
  "prosper",
  "greenville",
  "celina",
];

export const requiresWaterLocate = (city) =>
  waterLocateRequiredCities.includes(String(city || "").trim().toLowerCase());